import React from 'react'
import { IMyActivitiesExtraBlockProps } from './interface'

import './styles.scss'

const bc = 'my-activities-extra-block'

const MyActivitiesExtraBlock: React.FC<IMyActivitiesExtraBlockProps> = ({ activity, order }) => {
  return (
    <div>
      <div className={`${bc}__name`}>{`${order}. ${activity.get('name')}`}</div>
      <div
        className={`${bc}__description`}
        dangerouslySetInnerHTML={{ __html: activity.get('description') as string }}
      />
    </div>
  )
}

export default MyActivitiesExtraBlock
